export enum Env {
  Development = 'development',
  Test = 'test',
  Production = 'production',
  Demo = 'demo',
}

export const getEnv = (): Env => {
  if (import.meta.env.DEV) {
    return Env.Development;
  }
  const hostname = window.location.hostname;
  if (hostname.includes('test')) {
    return Env.Test;
  }
  if (hostname.includes('demo')) {
    return Env.Demo;
  }
  return Env.Production;
};

const ENV = getEnv();

interface EnvVariables {
  stripeKey: string;
  authRoot: string;
}

const variables: Record<Env, EnvVariables> = {
  development: {
    stripeKey: import.meta.env.VITE_STRIPE_KEY,
    authRoot: 'https://auth.magicdoor-test.com',
  },
  test: {
    stripeKey: import.meta.env.VITE_STRIPE_KEY,
    authRoot: 'https://auth.magicdoor-test.com',
  },
  production: {
    stripeKey: import.meta.env.VITE_STRIPE_KEY_PROD,
    authRoot: 'https://auth.magicdoor.com',
  },
  demo: {
    stripeKey: import.meta.env.VITE_STRIPE_KEY_PROD,
    authRoot: 'https://auth.magicdoor-demo.com',
  },
};

export const env = variables[ENV];
